
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import VideoPreview from "./video-analysis/VideoPreview";
import AnalysisResults from "./video-analysis/AnalysisResults";
import AnalyzingIndicator from "./video-analysis/AnalyzingIndicator";
import { useVideoAnalysis } from "@/hooks/useVideoAnalysis";

interface VideoAnalysisDialogProps {
  showDialog: boolean;
  setShowDialog: (show: boolean) => void;
  selectedVideo: {
    url: string;
    title: string;
  } | null;
}

const VideoAnalysisDialog = ({ 
  showDialog, 
  setShowDialog, 
  selectedVideo 
}: VideoAnalysisDialogProps) => {
  const {
    analyzing,
    analysisResult,
    analyzeVideo,
    downloadReport
  } = useVideoAnalysis();

  const handleAnalyzeVideo = async () => {
    if (!selectedVideo) return;
    await analyzeVideo(selectedVideo.url);
  };

  const handleDownloadReport = () => {
    downloadReport(analysisResult);
  };

  return (
    <Dialog open={showDialog} onOpenChange={setShowDialog}>
      <DialogContent className="sm:max-w-[900px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>3D Video Analysis</DialogTitle>
          <DialogDescription>
            Analyze player and ball movement using NVIDIA USD Search API.
          </DialogDescription>
        </DialogHeader>
        
        <VideoPreview 
          selectedVideo={selectedVideo}
          analyzing={analyzing}
          onAnalyze={handleAnalyzeVideo}
        />

        {analyzing && <AnalyzingIndicator />}
        
        {analysisResult && (
          <AnalysisResults 
            analysisResult={analysisResult}
            onDownloadReport={handleDownloadReport}
          />
        )}
        
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => setShowDialog(false)}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default VideoAnalysisDialog;
